import React from "react";
import classes from "./CustomerCard.module.css";
import { InstagramEmbed } from "react-social-media-embed";

function CustomerCard({ videoUrl, name }) {
    return (
        <div className={classes.customerCardContainer}>
            <div className={classes.imageContainer}>
            </div>
            <div className={classes.cardDescription}>
                <div className={classes.instagramWrapper}>
                    <InstagramEmbed key={videoUrl} embedPlaceholder={videoUrl} url={videoUrl} width={238} />
                </div>
            </div>
            <div className={classes.author}>
                <p>{name}</p>
            </div>
        </div>
    );
}

export default CustomerCard;